<template>
  <v-btn
    v-bind="$attrs"
    :text="isText ? 'text' : null"
    :variant="isText ? 'text' : $attrs.variant ?? undefined"
  >
    <slot />
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'VBtnAdapted',
  computed: {
    isText() {
      const hasTextAttr = this.$attrs.text === '' || this.$attrs.text === 'text';
      return this.$attrs.variant === 'text' || hasTextAttr;
    },
  },
});
</script>
